define('lq/runtimePiping',[
    'jquery',
    'lq/queryDispatcher',
    'drops/action/runtimeTypesProvider',
    'lq/dropFactory',
    'lq/parameterShell',
    'lq/runtimeBusyIndicator',
    'lq/runtimeErrorHandler',
    'lq/formatting',
    'lq/runtimeDispatcher',
    'lq/runtimeUrl',
    'lq/conditions/conditions',
    'lq/events/eventing',
    'lq/events/eventActionFactory',
    'lq/visibility/defaultVisibility',
    'lq/datasources',
    'lq/visibility/itemVisibility',
    'lq/required',
    'lq/queryString'
], function ($, QueryDispatcher, runtimeTypesProvider, DropFactory, ParameterShell, RuntimeBusyIndicator, RuntimeErrorHandler, Formatting, RuntimeDispatcher, RuntimeUrl, Conditions, Eventing, EventActionFactory, DefaultVisibility, Datasources, ItemVisibility, Required, QueryString) {
    'use strict';
    
    var RuntimePiping = function () {
    };

    RuntimePiping.createRoot = function (application, $app, history) {
        var piping = new RuntimePiping();
        piping.history = history;
        piping.$app = $app;
        piping.application = application;
        piping.busyIndicator = new RuntimeBusyIndicator($app);
        piping.errorHandler = new RuntimeErrorHandler(piping.busyIndicator, application, $app);
        piping.formatting = new Formatting(application.formatting, application.languageISOCode
            || navigator.userLanguage
            || navigator.language);
        piping.queryString = QueryString.initialize();
        piping.url = new RuntimeUrl(piping.queryString);
        return piping;
    };

    RuntimePiping.prototype.createChildPiping = function (action, parameters, rootDrop, $wrapper, $view, isReloaded) {
        var piping = new RuntimePiping();

        $.extend(piping, this);

        piping.$actionWrapper = $wrapper;
        piping.$actionView = $view;
        piping.dispatcher = new RuntimeDispatcher(piping.busyIndicator, action.actionVersion, action.masterPageVersion);
        piping.actionId = action.id;
        piping.actionInstanceId = action.instanceId;
        piping.masterPageId = action.view.data.masterPageId;
        piping.embeddable = action.view.data.embeddable;
        piping.dropFactory = new DropFactory(runtimeTypesProvider, true);
        piping.parameters = ParameterShell.createFrom(parameters.locals, parameters.globals, parameters.system);
        piping.conditions = new Conditions(action.conditions, piping);
        piping.eventing = new Eventing(action.events, piping, new EventActionFactory(rootDrop), isReloaded);
        piping.datasources = new Datasources();
        piping.visibility = new DefaultVisibility();
        piping.required = new Required();
        piping.queryDispatcher = new QueryDispatcher(piping);

        return piping;
    };

    // todo svb SPA review this
    RuntimePiping.prototype.fork = function (data, parentDrop, idOutput) {
        var childParameters = this.parameters.createChildScope(data);
        var childPiping = new RuntimePiping();
        var childQueryDispatcher = new QueryDispatcher(childPiping);

        return $.extend(
            childPiping,
            this,
            {
                visibility: new ItemVisibility(data, parentDrop),
                parameters: childParameters,
                queryDispatcher: childQueryDispatcher,
                idOfItem: data[idOutput]
            });
    };

    return RuntimePiping;
});
